import './index.css'

import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'

const element = document.querySelector('#root')

if (!element) {
  throw new Error(
    "Vio widget initialization error: could not find element with id 'root'."
  )
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.querySelector('#root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
